<template>
  <div class="flex flex-col h-full overflow-hidden font-[Cubic]">
    <ThreadsNav show-back :show-center="false" />
    <div class="flex-1 overflow-hidden">
      <div class="flex flex-col h-full overflow-hidden">
        <ThreadList
          class="flex-1"
          ref="threadList"
          v-if="mateId && coinRankId"
          @on-scroll="(h) => (height = h)"
          :enable-pull-load="false"
          :on-scroll-load="() => loadNextPage()"
        >
          <!-- 日志卡片列表 -->
          <div class="flex flex-col gap-1">
            <MissionListItem
              v-for="(item, index) in list"
              :key="index"
              :item="item"
              type="rank"
            />
          </div>
        </ThreadList>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { MateDispatch } from "@/types/entity";
import { onActivated, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { ApiGetMateDispatchPage } from "@/apis/dispatchMission";

const list = ref<MateDispatch[]>([]);
const route = useRoute();

const threadList = ref<ThreadListInstance>();
const mateId = ref<number | undefined>(undefined);
const coinRankId = ref<number | undefined>(undefined);
const height = ref(0);

let oldMateId: number | undefined = undefined;
const reload = async () => {
  mateId.value = Number(route.query.mateId);
  coinRankId.value = Number(route.query.coinRankId);
  oldMateId = Number(route.query.mateId);

  list.value = [];
  threadList.value?.resetScrollLoadingState();
};

watch(
  () => route.query.mateId,
  (val) => {
    if (route.name === "missionDispatchRank" && Number(val) !== oldMateId) {
      reload();
    }
  },
  {
    immediate: true,
  }
);

const loadNextPage = async () => {
  if (list.value.length !== 0 && list.value.length % 5 !== 0) return false;
  const page = list.value.length / 5 + 1;

  const res = await ApiGetMateDispatchPage({
    filter: {
      mateId: mateId.value,
      coinRankId: coinRankId.value,
    },
    pagination: { page, perPage: 5 },
    sort: { field: "dtUpdate", order: "desc" },
  });

  list.value = [...list.value, ...res.page.data];

  return res.page.data.length === 5;
};

onActivated(() => {
  threadList.value?.scrollTo(height.value);
});
</script>
